export default __webpack_public_path__ + "static/media/frontend.0019aa8d.jpg";